import type { AtualizarCriterioDto, CriarCriterioDto, CriterioResponse, ExemploCriterioResponse } from '@triade/contracts';
import { ehDecimal } from '@/lib/format';
import { useConsulta, useMutacao } from './base';

/** Criterios de rateio da empresa (GET /criterios-rateio). A tela de apropriacao filtra os ativos. */
export function useCriterios() {
  return useConsulta<CriterioResponse[]>(['criterios'], '/criterios-rateio');
}

export function useCriterio(id: string | undefined) {
  return useConsulta<CriterioResponse>(['criterios', id], `/criterios-rateio/${id}`, { ativo: !!id });
}

export function useCriarCriterio() {
  return useMutacao<CriterioResponse, CriarCriterioDto>({
    metodo: 'POST',
    caminho: () => '/criterios-rateio',
    corpo: (v) => v,
    invalidar: [['criterios'], ['centros']],
  });
}

export function useAtualizarCriterio() {
  return useMutacao<CriterioResponse, { id: string } & AtualizarCriterioDto>({
    metodo: 'PATCH',
    caminho: (v) => `/criterios-rateio/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['criterios'], ['centros']],
  });
}

/** Painel Exemplo do criterio (GET /criterios-rateio/:id/exemplo?valor=). So dispara com id e valor decimal valido. */
export function useExemploCriterio(id: string | undefined, valor: string | undefined) {
  return useConsulta<ExemploCriterioResponse>(['criterios', 'exemplo', id, valor], `/criterios-rateio/${id}/exemplo`, {
    query: { valor },
    ativo: !!id && ehDecimal(valor),
  });
}
